module.exports = __webpack_public_path__ + "b0639f2bab6ce903e228810decb3bfef.pdf";